import { CascadiaJsonFormContext } from "@certn/forms";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { useContext } from "react";

import { EducationDocumentsControl } from "./EducationDocumentsControl";
import { EducationtDocumentsSummaryControl } from "./EducationDocumentsSummaryControl";

/* eslint-disable react-hooks/rules-of-hooks */
function _EducationDocumentsControl(props: ArrayControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <EducationtDocumentsSummaryControl {...props} />;
  }

  return <EducationDocumentsControl {...props} />;
}
/* eslint-enable react-hooks/rules-of-hooks */

export const EducationDocumentsControlRenderer = withJsonFormsArrayControlProps(
  _EducationDocumentsControl
);
